// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n7j_","colBig":"styles_colBig__sYSPT","colSmall":"styles_colSmall__2zg2V"};